<template>
  <Sidebar />
  <Content class="analytics-overview-content analytics-big-box" v-if="store.state.user_data.merchant_account_id">
    <div class="inner inner-box">
      <AnalyticsHeader v-if="head_key" :show_check_box="true" :data_statistic="data_statistic" @handleSortLink="sortLinkClick" />
      <div class="main">
        <Scrollbar class="left" id="body">
          <!-- :products_num="[1,2]" is fake data for StorefrontSummary, products_num is for one creator -->
          <StorefrontSummary
            ref="summary"
            v-if="can_start"
            :is_hide_date="true"
            :chart_id="'overview'"
            @update-data="getDoughnut()"
            :api_url="summary_api_url"
            :products_num="[1, 2]"
            :is_show_posts="true"
            :is_show_crt="true"
            :date_range="{ start_date: start_date, end_date: end_date }"
            @handleSortLink="sortLinkClick"
            :show_last_datetime="true"
            :selected_creator_tags="selected_creator_tags"
            :creator_tag_operation_type="creator_tag_operation_type"
            :is_link_only="is_link_only"
            :no_title="true"
            :show_views_prop="sortlink_data === 'shortlink' ? false : undefined"
          />

          <!-- id="scroll-left" 9389 #18改成最多SHOW 8個 -->
          <ProductList
            :is_loading="is_loading_products"
            :is_loading_page="is_loading_products_page"
            :date_range="{ start_date: start_date, end_date: end_date }"
            :title="'Top Products'"
            :data="products"
            :sort_index="product_list_sort_index"
            @update-sort="getProductList"
            :key="'product-list-' + product_list_filter"
            :data_statistic="data_statistic"
            :show_data_statistic="false"
            :init_sortlink="sortlink_data"
            :is_swiper="true"
          />

          <div class="load-more-box">
            <el-button class="w-100" v-if="current_page < last_page" @click="router.replace('/analytics/products')"
              >See All</el-button
            >
          </div>
          <div class="top-20" v-if="!top_post.loading && !is_link_only">
            <TopBrandPost
              :title="'Top Performing Branded Content'"
              :posts="top_post.data"
              :posts_value="top_post"
              @clickPost="clickPost"
              @updateSort="updateSort"
              :had_navi="false"
              @updateTag="updateTag"
              :selected_tags="selected_tags"
              :tag_text="default_text"
              :now_tab="1"
              :creator_show="true"
              :is_swiper="true"
            />
          </div>
          <div class="load-more-box">
            <el-button class="w-100" v-if="top_post.data_total > 0" @click="router.replace('/analytics/content')"
              >See All</el-button
            >
          </div>
          <Loading class="static" v-if="top_post.loading" />
        </Scrollbar>

        <Scrollbar class="right">
          <TopCreator
            v-if="can_start"
            :start_date="start_date"
            :end_date="end_date"
            :init_sortlink="sortlink_data"
            :is_link_only="is_link_only"
            :selected_creator_tags="selected_creator_tags"
            :creator_tag_operation_type="creator_tag_operation_type"
            ref="top_creator"
            @top_data="childApiDone.top_creator = true"
          />
          <div class="doughnut-box">
            <div class="title">
              <span>Traffic Source</span>
              <Dropdown
                :items="doughnut_select"
                :direction_type="'right'"
                :icon_direction_type="'right'"
                :key="'source-' + sortlink_data"
                @update-dropdown="getDoughnutSource"
                ref="dropdown_source"
              />
            </div>
            <Loading class="static" v-if="is_loading_source" />
            <Doughnut v-else :color="source_doughnut_color" ref="source" :key="is_loading_source" />
          </div>
          <div class="doughnut-box">
            <div class="title">
              <span>Operating Systems</span>
              <Dropdown
                :items="doughnut_select"
                :direction_type="'right'"
                :icon_direction_type="'right'"
                :key="'device-' + sortlink_data"
                @update-dropdown="getDoughnutDevice"
                ref="dropdown_device"
              />
            </div>
            <Loading class="static" v-if="is_loading_device" />
            <Doughnut v-else :color="device_doughnut_color" ref="device" :key="is_loading_device" />
          </div>
        </Scrollbar>
      </div>
    </div>
  </Content>
</template>

<script setup>
import { ref, reactive, watch, onMounted, onBeforeUnmount, nextTick, inject, getCurrentInstance, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import Sidebar from '@/components/Sidebar.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import AnalyticsHeader from '@/components/analytics/AnalyticsHeader.vue';
import Content from '@/components/ui/Content.vue';
import ProductList from '@/components/product/ProductList.vue';
import StorefrontSummary from '@/components/summary/StorefrontSummary.vue';
import TopCreator from '@/components/summary/TopCreator.vue';
import Dropdown from '@/components/ui/Dropdown.vue';
import Doughnut from '@/components/summary/Doughnut.vue';
import Loading from '@/components/ui/Loading.vue';
import moment from 'moment';
import TopBrandPost from '@/components/TopBrandPost.vue';
import { SwitchTopSort, get_all_post_data } from '@/utils/ContentSwitchFun.js';
import { handleMaxMinFun, dataSourceToApi } from '@/utils/SwitchFun.js';
import { ElButton } from 'element-plus';

const store = useStore();
const router = useRouter();
const { proxy } = getCurrentInstance();
const $ajax = proxy.$ajax;
const EventBus = proxy.EventBus;

// Template refs
const summary = ref(null);
const top_creator = ref(null);
const dropdown_source = ref(null);
const dropdown_device = ref(null);
const source = ref(null);
const device = ref(null);

// Data
const data = ref(false);
const source_doughnut_color = ['#C32AA3', '#27364B', '#FAA378', '#1DB954', '#FF0000'];
const device_doughnut_color = ['#1DA1F2', '#4F4F4F', '#1DB954'];
const products = ref([]);
const is_link_only = computed(() => {
  return store.state.user_data?.merchant_account.platform_type === 'linkonly';
});
// 与 StorefrontSummary.vue 的 show_views 完全一致的 views 显示逻辑（overview 层级 user_data 为 null）。
const show_views = computed(() => {
  if (sortlink_data.value === 'shortlink') return false;
  return !is_link_only.value || (is_link_only.value && store.state.list_has_historical_storefront_tracking);
});
const doughnut_select = computed(() => {
  return [
    ...(show_views.value ? [{ id: 1, text: 'Views' }] : []),
    { id: 2, text: 'Clicks' },
    { id: 3, text: 'Sales' },
    { id: 4, text: 'Sales Value' },
  ];
});
const is_loading = ref(true);
const is_loading_products_page = ref(false);
const selected_creator_tags = ref([]);
const creator_tag_operation_type = ref('or');
const is_loading_products = ref(true);
const is_loading_source = ref(true);
const is_loading_device = ref(true);
const start_date = ref(moment().add(-30, 'days').toDate());
const end_date = ref(moment().add(-1, 'days').toDate());
const product_list_filter = ref('');
const product_list_sort_index = ref(0);
const current_page = ref(1);
const last_page = ref(1);
const sourceList = ['instagram', 'tiktok', 'youtube', 'motom', 'search', 'other', 'linktree', 'beacons'];
const deivceList = ['android', 'ios', 'windows', 'others'];
const summary_api_url = '/analytics/merchant-account-statistic';
const product_sort = reactive({
  key: 'views',
  val: 'desc',
});
const top_post = reactive(get_all_post_data);
const default_text = ref('Tags: All');
const tags = ref([]);
const selected_tags = ref([]);
const can_start = ref(false);
const sortlink_data = ref('all');
const data_statistic = ref(null);
const childApiDone = reactive({
  doughnut_source: false,
  doughnut_device: false,
  top_creator: false,
});
const curated_check = ref(false);
const keyword = ref('');
const head_key = ref(0);

// Watch
watch(
  () => store.state.user_data.merchant_account_id,
  (val) => {
    startFunction();
  }
);

watch(
  childApiDone,
  (val) => {
    if (val.doughnut_source && val.doughnut_device && val.top_creator) {
      getTop();
    }
  },
  { deep: true }
);

// Methods
const sortLinkClick = (val) => {
  sortlink_data.value = val;
  getProductList();
  summary.value.chart_type = val === 'shortlink' ? 'click' : 'view';
  summary.value.sortlink_data = sortlink_data.value;
  summary.value.getData();
  top_creator.value.sortlink_data = sortlink_data.value;
  top_creator.value.fetchData();
  getDoughnut();
};

const startFunction = () => {
  if (store.state.user_data.merchant_account_id) {
    sortlink_data.value = store.state.save_sortlink_data;
    can_start.value = true;

    // Initialize dates from store if available
    if (store.state.save_analytics_start_date && store.state.save_analytics_end_date) {
      start_date.value = store.state.save_analytics_start_date;
      end_date.value = store.state.save_analytics_end_date;
    }

    let checkTime = handleMaxMinFun(start_date.value, end_date.value, proxy);
    start_date.value = checkTime[0];
    end_date.value = checkTime[1];
    getProductList();
  }
};

const getTopCreator = () => {
  if (store.state.user_data.merchant_account_id) {
    top_creator.value.type = 1;
    top_creator.value.fetchData();
  }
};

const getDoughnut = (data) => {
  setTimeout(() => {
    if (data) {
      data_statistic.value = data.data;
    }
    dropdown_source.value.selected_index = 0;
    dropdown_device.value.selected_index = 0;
    getDoughnutSource();
    getDoughnutDevice();
    head_key.value += 1;
  }, 10);
};

const getDoughnutSource = (obj) => {
  if (store.state.user_data.merchant_account_id) {
    is_loading_source.value = true;
    let sort_key = show_views.value ? 'page_views' : 'click';
    if (obj) {
      switch (obj.id) {
        case 1:
          sort_key = 'page_views';
          break;
        case 2:
          sort_key = 'click';
          break;
        case 3:
          sort_key = 'sales';
          break;
        case 4:
          sort_key = 'sales_value';
          break;
        default:
          break;
      }
    }
    let s = moment(start_date.value).format('YYYY-MM-DD');
    let e = moment(end_date.value).format('YYYY-MM-DD');
    let api = `/analytics/break-down/source?start_date=${s}&end_date=${e}&sort_key=${sort_key}&is_include_shortlink_data=${dataSourceToApi(sortlink_data.value)}`;

    // Add creator tag filters
    if (selected_creator_tags.value && selected_creator_tags.value.length > 0) {
      selected_creator_tags.value.forEach((tag) => {
        api += `&creator_tag_ids[]=${tag.id}`;
      });
      api += `&operation_type=${creator_tag_operation_type.value}`;
    }

    // Add tier filter. No operation_type: a creator sits in exactly one tier, so it is always Or
    (store.state.save_selected_tiers || []).forEach((tier) => {
      api += `&tier_ids[]=${tier.id}`;
    });

    $ajax(api, {
      method: 'get',
      withCredentials: true,
    }).then((res) => {
      is_loading_source.value = false;
      childApiDone.doughnut_source = true;

      //handle if name is abbr
      let handleData = res.data.data.map((e) => {
        let index = -1;
        if (e.name.length == 1) {
          index = sourceList.findIndex((ee) => {
            return ee[0] == e.name;
          });
        }
        return {
          ...e,
          name: index !== -1 ? sourceList[index] : e.name,
        };
      });

      nextTick(() => {
        if (source.value)
          source.value.update({
            data: handleData,
            type: sort_key,
          });
      });
    });
  }
};

const getDoughnutDevice = (obj) => {
  if (store.state.user_data.merchant_account_id) {
    is_loading_device.value = true;
    childApiDone.doughnut_device = true;
    let sort_key = show_views.value ? 'page_views' : 'click';
    if (obj) {
      switch (obj.id) {
        case 1:
          sort_key = 'page_views';
          break;
        case 2:
          sort_key = 'click';
          break;
        case 3:
          sort_key = 'sales';
          break;
        case 4:
          sort_key = 'sales_value';
          break;
        default:
          break;
      }
    }
    let s = moment(start_date.value).format('YYYY-MM-DD');
    let e = moment(end_date.value).format('YYYY-MM-DD');
    let api = `/analytics/break-down/device-use?start_date=${s}&end_date=${e}&sort_key=${sort_key}&is_include_shortlink_data=${dataSourceToApi(sortlink_data.value)}`;

    // Add creator tag filters
    if (selected_creator_tags.value && selected_creator_tags.value.length > 0) {
      selected_creator_tags.value.forEach((tag) => {
        api += `&creator_tag_ids[]=${tag.id}`;
      });
      api += `&operation_type=${creator_tag_operation_type.value}`;
    }

    // Add tier filter. No operation_type: a creator sits in exactly one tier, so it is always Or
    (store.state.save_selected_tiers || []).forEach((tier) => {
      api += `&tier_ids[]=${tier.id}`;
    });

    $ajax(api, {
      method: 'get',
      withCredentials: true,
    }).then((res) => {
      is_loading_device.value = false;

      //handle if name is abbr
      let handleData = res.data.data.map((e) => {
        let index = -1;
        if (e.name.length == 1) {
          index = deivceList.findIndex((ee) => {
            return ee[0] == e.name;
          });
        }

        return {
          ...e,
          name: index !== -1 ? deivceList[index] : e.name,
        };
      });

      nextTick(() => {
        if (device.value)
          device.value.update({
            data: handleData,
            type: sort_key,
          });
      });
    });
  }
};

const getProductList = (obj) => {
  if (store.state.user_data.merchant_account_id) {
    is_loading_products.value = true;
    if (document.getElementById('body'))
      document.getElementById('body').scrollTop = document.getElementById('body').scrollTop - 50;
    let s = moment(start_date.value).format('YYYY-MM-DD');
    let e = moment(end_date.value).format('YYYY-MM-DD');
    keyword.value = obj ? obj.keyword : keyword.value;

    let api = `/creator/product-list?page=${current_page.value}&start_date=${s}&end_date=${e}&sort_key=${product_sort.key}&sort_val=${product_sort.val}&is_include_shortlink_data=${dataSourceToApi(sortlink_data.value)}&product_keyword=${keyword.value}`;

    if (obj) {
      product_list_sort_index.value = obj.type.id - 1;

      if (obj.curated_check !== undefined) {
        curated_check.value = obj.curated_check;
      }

      switch (obj.type.id) {
        case 1:
          product_sort.key = 'views';
          product_sort.val = 'desc';
          break;
        case 2:
          product_sort.key = 'views';
          product_sort.val = 'asc';
          break;
        case 3:
          product_sort.key = 'click';
          product_sort.val = 'desc';
          break;
        case 4:
          product_sort.key = 'click';
          product_sort.val = 'asc';
          break;
        case 5:
          product_sort.key = 'sales';
          product_sort.val = 'desc';
          break;
        case 6:
          product_sort.key = 'sales';
          product_sort.val = 'asc';
          break;
        case 7:
          product_sort.key = 'sales_value';
          product_sort.val = 'desc';
          break;
        case 8:
          product_sort.key = 'sales_value';
          product_sort.val = 'asc';
          break;
        default:
          break;
      }

      current_page.value = 1;
      let newApi = `/creator/product-list?page=${current_page.value}&start_date=${obj.date.start}&end_date=${obj.date.end}&is_include_shortlink_data=${dataSourceToApi(sortlink_data.value)}&curated_check=${curated_check.value}`;
      api = `${newApi}&sort_key=${product_sort.key}&sort_val=${product_sort.val}`;
    }

    if (current_page.value > 1) is_loading_products_page.value = true;

    // Add creator tag filters
    if (selected_creator_tags.value && selected_creator_tags.value.length > 0) {
      selected_creator_tags.value.forEach((tag) => {
        api += `&creator_tag_ids[]=${tag.id}`;
      });
      api += `&operation_type=${creator_tag_operation_type.value}`;
    }

    // Add tier filter. No operation_type: a creator sits in exactly one tier, so it is always Or
    (store.state.save_selected_tiers || []).forEach((tier) => {
      api += `&tier_ids[]=${tier.id}`;
    });

    $ajax(api, {
      method: 'get',
      withCredentials: true,
    }).then((res) => {
      if (current_page.value === 1)
        //9389 #18改成最多SHOW 8個
        products.value = res.data.data.filter((e, k) => {
          return k < 8;
        });
      else
        res.data.data.forEach((p) => {
          products.value.push(p);
        });
      product_list_filter.value = api.substring(api.indexOf('?') + 1);
      current_page.value = Number(res.data.current_page);
      last_page.value = Number(res.data.last_page);

      setTimeout(() => {
        is_loading_products.value = false;
        is_loading.value = false;
        is_loading_products_page.value = false;
      }, 1000);
    });
  }
};

const handleScroll = () => {
  let body = document.getElementById('body').scrollTop + 420;
  let scroll = document.getElementById('scroll-left').offsetHeight;

  if (body > scroll && !is_loading_products.value && current_page.value < last_page.value) {
    current_page.value++;
    getProductList();
  }
};

const updateSort = (id) => {
  let getVal = SwitchTopSort(id.id);
  top_post.sort.sort_key = getVal.key;
  top_post.sort.sort_val = getVal.val;
  top_post.sort_index = top_post.sort_select.findIndex((obj) => obj.id === id.id);
  top_post.drop_key += 1;
  getTop();
};

const getTop = async () => {
  if (!store.state.user_data.merchant_account_id) {
    return;
  }

  top_post.loading = true;

  // Build base parameters once
  const baseParams = {
    merchant_account_id: store.state.user_data.merchant_account_id,
    start_date: moment(start_date.value).format('YYYY-MM-DD'),
    end_date: moment(end_date.value).format('YYYY-MM-DD'),
    sort_key: top_post.sort.sort_key,
    sort_val: top_post.sort.sort_val,
    page: top_post.sort.page,
    per_page: 8,
    with_extra_count: '',
    brand_post_only: 1,
  };

  if (selected_tags.value.length > 0) {
    baseParams.tag_ids = selected_tags.value.map((e) => e.id);
  }

  // Add creator tag filters (different from social post tags)
  if (selected_creator_tags.value && selected_creator_tags.value.length > 0) {
    baseParams.creator_tag_ids = selected_creator_tags.value.map((tag) => tag.id);
    baseParams.operation_type = creator_tag_operation_type.value;
  }

  // Tier filter, no operation_type: a creator sits in exactly one tier
  if (store.state.save_selected_tiers?.length > 0) {
    baseParams.tier_ids = store.state.save_selected_tiers.map((tier) => tier.id);
  }

  // Initialize empty data structure for immediate rendering
  const results = {
    tikTokPosts: [],
    instagramOthers: [],
    reels: [],
    stories: [],
  };

  // Initialize UI with empty data
  top_post.data = [
    {
      svg: 'tiktok-pure',
      which: 'TikTok',
      title: '',
      total: 0,
      data: [],
      title_show: true,
    },
    {
      svg: 'instagram',
      which: 'Instagram',
      title: 'In-Feed',
      total: 0,
      data: [],
      title_show: true,
    },
    {
      svg: 'instagram',
      which: 'Instagram',
      title: 'Reels',
      total: 0,
      data: [],
      title_show: false,
    },
    {
      svg: 'instagram',
      which: 'Instagram',
      title: 'Stories',
      total: 0,
      data: [],
      title_show: false,
    },
  ];
  top_post.data_total = 0;

  // Define request configurations
  const requestConfigs = [
    { platform: 'tikTok', type: 'video', target: 'tikTokPosts', index: 0 },
    { platform: 'instagram', type: 'post', target: 'instagramOthers', index: 1 },
    { platform: 'instagram', type: 'reel', target: 'reels', index: 2 },
    { platform: 'instagram', type: 'story', target: 'stories', index: 3 },
  ];

  try {
    // Process requests and render each one as it completes
    for (const config of requestConfigs) {
      const params = {
        ...baseParams,
        social_platform: config.platform,
        social_post_type: config.type,
      };

      const response = await $ajax('creator/get-social-account-posts', {
        params,
        method: 'get',
      });

      // Extract and limit to 8 items per request
      const data = response.data.data.social_posts.data.slice(0, 8);
      results[config.target] = data;

      // Update UI immediately as each request completes
      const instagramTotal = results.instagramOthers.length + results.reels.length + results.stories.length;

      top_post.data[config.index].data = data;

      // Update totals for Instagram items
      if (config.platform === 'instagram') {
        top_post.data[1].total = instagramTotal;
        top_post.data[2].total = instagramTotal;
        top_post.data[3].total = instagramTotal;

        // Update title_show for Instagram items
        top_post.data[2].title_show = results.instagramOthers.length === 0;
        top_post.data[3].title_show = results.instagramOthers.length === 0 && results.reels.length === 0;
      } else {
        top_post.data[config.index].total = data.length;
      }

      // Update total count
      top_post.data_total =
        results.tikTokPosts.length + results.instagramOthers.length + results.reels.length + results.stories.length;
    }
  } catch (err) {
    console.error('Error fetching top posts:', err);
    top_post.data_total = 0;
  } finally {
    top_post.loading = false;
  }
};

const updateTag = (tag) => {
  if (tag === false) {
    selected_tags.value = [];
  } else if (selected_tags.value.findIndex((o) => o.id === tag.id) === -1) {
    selected_tags.value.push(tag);
  } else {
    selected_tags.value = selected_tags.value.filter((o) => o.id !== tag.id);
  }

  if (selected_tags.value.length === 0) {
    default_text.value = 'Tags: All';
  } else {
    default_text.value = 'Tags: ';
    selected_tags.value.forEach((v, k) => {
      default_text.value += v.text + (k === selected_tags.value.length - 1 ? '' : ', ');
    });
  }

  getTop();
};

const clickPost = (val) => {};

// Lifecycle hooks
onMounted(() => {
  if (!store.state.user_data.permission_list.analytics.viewPerformanceSummaries.permission) {
    router.push('/creator/list');
    return;
  }
  // Initialize creator tags from store BEFORE startFunction (so API calls include tags)
  if (store.state.save_selected_tags && store.state.save_selected_tags.length > 0) {
    selected_creator_tags.value = store.state.save_selected_tags;
    creator_tag_operation_type.value = store.state.save_tag_operation_type || 'or';
  }

  startFunction();
  store.state.creator_data = null;
  EventBus.off('update-date');
  EventBus.on('update-date', (obj) => {
    console.log('!update-date!');
    start_date.value = moment(obj.start_date).format('YYYY-MM-DD');
    end_date.value = moment(obj.end_date).format('YYYY-MM-DD');
    products.value = [];
    current_page.value = 1;
    last_page.value = 1;

    setTimeout(() => {
      getTopCreator();
      getProductList();
      getDoughnut();
      getTop();
    }, 100);
  });

  // Listen for creator tag updates - following same pattern as date updates
  EventBus.off('analytics-tags-updated');
  EventBus.on('analytics-tags-updated', (data) => {
    console.log('!analytics-tags-updated!', data);
    selected_creator_tags.value = data.tags;
    creator_tag_operation_type.value = data.operation_type;
    // Refresh data with new tag filters
    products.value = [];
    current_page.value = 1;
    last_page.value = 1;

    setTimeout(() => {
      getProductList();
      if (summary.value) {
        summary.value.getData();
      }
      if (top_creator.value) {
        top_creator.value.fetchData();
      }
      getTop();
    }, 100);
  });

  // Tier updates refetch the same set. The store already holds the new selection,
  // so unlike the tags there is no local state to sync first.
  EventBus.off('analytics-tiers-updated');
  EventBus.on('analytics-tiers-updated', () => {
    products.value = [];
    current_page.value = 1;
    last_page.value = 1;

    setTimeout(() => {
      getProductList();
      if (summary.value) {
        summary.value.getData();
      }
      if (top_creator.value) {
        top_creator.value.fetchData();
      }
      getTop();
      getDoughnut();
    }, 100);
  });

  EventBus.on('updated-all-post-tag', (tagsData) => {
    if (selected_tags.value)
      selected_tags.value.forEach((tag, tag_index) => {
        const index = tagsData.findIndex((o) => o.id === tag.id);
        if (index === -1) {
          // remove this tag
          updateTag(tag);
        }
        getTop();
      });

    tags.value = tagsData;
  });
});

onBeforeUnmount(() => {
  // Clean up event listeners when leaving the component
  EventBus.off('update-date');
  EventBus.off('analytics-tags-updated');
  EventBus.off('analytics-tiers-updated');
  EventBus.off('updated-all-post-tag');
});
</script>

<style lang="scss">
@mixin flexCenter() {
  display: flex;
  align-items: center;
}

.analytics-overview-content {
  .inner {
    height: 100%;
    // display: flex;
    padding: 24px 48px; //24px 48px 0 48px;

    .main {
      height: calc(100% - 126px);
      display: flex;
      //padding-top: 36px;

      .left {
        width: 70%;
        min-width: 600px;

        .product-list {
          margin-top: 36px;

          .product-modal {
            z-index: 2;
          }
        }

        .load-more-box {
          width: 100%;
          @include flexCenter();
          justify-content: center;
          margin-top: 12px;

          .ui-button {
            width: 100%;
            text-align: center;
            @include flexCenter();
            justify-content: center;
          }
        }

        .top-20 {
          margin-top: 24px;

          .top-brand-post-box .title {
            padding: 16px 0px;
          }

          .top-brand-post-box .tab-box {
            margin-top: -44px;
            padding: 0;
            margin-bottom: 16px;
          }
        }
      }

      .right {
        width: 30%;
        min-width: 340px;
        padding-left: 16px;

        .top-creator {
          margin-bottom: 16px;

          .creator-modal {
            z-index: 2;
          }
        }

        .doughnut-box {
          margin-top: 16px;
          padding: 12px;
          border: 1px solid var(--border);
          border-radius: 10px;

          .title {
            display: flex;
            align-items: center;
            font: var(--font-demi-16);
            color: var(--black-90);

            span {
              flex: 1;
            }

            .dropdown {
              width: fit-content;
            }
          }
        }
      }
    }
  }

  .storefront-summary .chart-box {
    overflow: hidden;
  }
}
</style>
